module.exports = __webpack_public_path__ + "img/supplyOne-01.09e9f680.jpg";